import React from 'react';
import Question from 'src/sections/team/Question';

function QuestionPage(props) {
    return <Question />;
}

export default QuestionPage;